import React from "react";
import { Typography } from "antd";

import {
  Modal,
  Header,
  DoneContainer,
  DoneFrame,
  DoneText,
  Small,
} from "src/components/SuccessModal/styles/successModal";

import NiceModal, { useModal } from "@ebay/nice-modal-react";

import { useHistory } from "react-router";
import { scrim } from "src/theme/ui";
import { Button, DialogActions, DialogMark } from "src/components/ui";

export default NiceModal.create(
  ({
    title,
    successMessage,
    definition,
    icon,
    smallText,
  }: {
    title?: string;
    successMessage: string;
    definition: any;
    icon: any;
    smallText?: string;
  }) => {
    const modal = useModal();
    const history = useHistory();

    const onOk = () => {
      modal.hide();
      history.push("/");
    };

    return (
      <Modal
        wrapClassName="fina-dialog"
        maskStyle={{ background: scrim, backdropFilter: "none" }}
        title={<Header>{title ?? ""}</Header>}
        visible={modal.visible}
        /* The corner X was drawn on every one of these dialogs and wired to
           nothing — `onCancel={null}`, so pressing it did not close, dismiss
           or navigate. A control that does nothing is worse than no control,
           and this one sits on the last screen of an order flow. It dismisses
           now; Done is still the way on. */
        onCancel={() => modal.hide()}
        afterClose={() => modal.remove()}
        width={440}
        footer={[
          <DialogActions key="customFooter">
            {/* The design system's button, not the legacy one: that came out
                62px tall with a 5px corner and an arrow glyph beside the
                word — measured on screen — against the 36px and 9px corner
                every other dialog in the flow closes on. */}
            <Button
              variant="primary"
              size="lg"
              onClick={onOk}
              className="test-success-button"
            >
              Done
            </Button>
          </DialogActions>,
        ]}
      >
        <DoneContainer>
          {/* Was the caller's illustration, drawn at its natural size. A
              confirmation wears the same mark as every other dialog that
              reports an outcome; the `icon` prop is left in the signature so
              the callers do not all have to change at once. */}
          <DialogMark tone="success" />
          <Typography.Text>
            <DoneFrame>
              <DoneText>
                {successMessage ?? ""}
              </DoneText>
            </DoneFrame>
          </Typography.Text>
          {smallText && <Small>{smallText}</Small>}
          <DoneFrame>
            <Typography.Text>{definition}</Typography.Text>
          </DoneFrame>
        </DoneContainer>
      </Modal>
    );
  },
);
